
import Service from '@/service'
import PositionLog from '@/data/position_log'

import WX_API from '@/utils/wx_api'

const viewLog = (option) => {
    PositionLog.log('you_like', option)
}
const handleListener = (res, ids) => {
    if (res.intersectionRect.bottom) {
        ids.forEach((item, i) => viewLog({
            id: item.log_id,
            pos: i,
            pos_name: item.position
        }))
    }
}

let Obs = []
let task
export default {
    onLoad () {
        PositionLog.refresh('you_like')
    },
    onUnload () {
        task && clearTimeout(task)
        Obs.forEach(item => item.disconnect())
    },
    methods: {
        initLog_1_3 (col1, col3) {
            // task = setTimeout(() => {
            //     const observer1 = WX_API.observerRelativeViewPort(`#${col1.dom_id}`, {
            //         success: (res) => handleListener(res, col1.ids)
            //     }, this.$mp.component)
            //     const observer2 = WX_API.observerRelativeViewPort(`#${col3.dom_id}`, {
            //         success: (res) => handleListener(res, col3.ids)
            //     }, this.$mp.component)
            //     observer1 && Obs.push(observer1)
            //     observer2 && Obs.push(observer2)
            // }, 800)
        },
        clickHouse (e) {
            const { id, pos_name, index } = e.currentTarget.dataset
            // Service.interestingEvent({
            //     interesting_id: id,
            //     event: 'click',
            //     pos_name,
            //     pos: index
            // })
            this.$router.push({
                path:e.currentTarget.dataset.href
            })
        }
    }
}
